import { Token } from 'config/types'
import { TransactionStatusEnum } from 'config/types/transaction'
import Column from 'layout/Components/Column'
import { RowBetween, RowMiddle } from 'layout/Components/Row'
import styled from 'styled-components'
import OpenEffect from 'UIKit/OpenEffect'
import Text from 'UIKit/Text'
import TokenLogo from 'UIKit/TokenLogo'
import {
  RowDisplayCurrencyAmountSymbolItem,
  TransactionDate,
  TransactionStatus,
} from 'views/Profile/Transactions/components/styled'

const ResultInfo = ({
  token,
  value,
  status,
  createTime,
}: {
  token: Token
  value: string
  status: TransactionStatusEnum
  createTime: number
}) => {
  return (
    <OpenEffect>
      <RowBetween>
        <RowMiddle>
          <TokenLogo token={token} size={32} networkImageProps={{ width: 16, height: 16 }} />
          <Column ml="12px">
            <Text color="text_primary" fontSize="14px" fontWeight="600">
              {token?.name}
            </Text>
            <TransactionDate
              fontSize="12px"
              lineHeight="20px"
              date={createTime}
              color="text_tertiary"
              textAlign="left"
              width="max-content"
            />
          </Column>
        </RowMiddle>

        <Column alignItems="flex-end">
          <StyledValue color="text_secondary" token={token} value={value} hideLogo />
          <TransactionStatus lineHeight="20px" status={status} />
        </Column>
      </RowBetween>
    </OpenEffect>
  )
}

const StyledValue = styled(RowDisplayCurrencyAmountSymbolItem)`
  * {
    font-size: 14px !important;
  }
`

export default ResultInfo
